<template>
  <div class="no-items-container" :class="{ 'is-card': !transparent }">
    <div class="image-wrapper">
      <img src="/img/member-img/no-items.svg" alt="No Items" />
    </div>
    <p class="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'NoItems',
  props: {
    message: {
      type: String,
      default: 'No data available'
    },
    transparent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.no-items-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  width: 100%;
  min-height: calc(100vh - 160px); /* Fill most of the viewport height */
  height: 100%;
  flex-grow: 1;
  grid-column: 1 / -1;
}

.is-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.image-wrapper {
  margin-bottom: 32px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.image-wrapper img {
  width: 280px; /* Larger illustration for desktop */
  height: auto;
  object-fit: contain;
  max-width: 100%;
}

.message {
  font-size: 18px;
  color: #6B7280;
  margin: 0;
  font-weight: 500;
  line-height: 1.5;
  max-width: 400px;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .no-items-container {
    padding: 40px 20px;
    min-height: 300px;
  }
  
  .image-wrapper {
    margin-bottom: 24px;
  }

  .image-wrapper img {
    width: 200px; /* Smaller illustration for mobile */
  }
  
  .message {
    font-size: 16px;
  }
}
</style>
